// Hand-written companion to the codegen output in `./data.ts`.
//
// `rtk-openapi.recalc.config.cjs` only lists `data.ts` (and its sibling
// endpoint files) as `outputFiles`, so re-running the recalc OpenAPI codegen
// never touches this file - customizations here survive regeneration.
//
// `dataGetCollectionAsyncByqueryOptions`'s generated `query()` passes the
// `timestamp` arg (a `string[]` holding e.g. `['ge(...)', 'lt(...)']`)
// straight through as a single `params.Timestamp` value. `fetchBaseQuery`
// serializes params via the native `URLSearchParams` constructor, which
// stringifies an array value by joining it with commas (e.g.
// `Timestamp=ge(...),lt(...)`) instead of repeating the key
// (`Timestamp=ge(...)&Timestamp=lt(...)`) - the format the API actually
// requires for range filters, causing a "invalid format" error. This
// override rebuilds the URL by hand so each `timestamp` entry becomes its
// own `Timestamp` query parameter, mirroring what the old hand-written
// `src/api/recalc/endpoints/dataApiSlice.jsx` `getData` query used to do.
import { recalcOpenApi } from './data';

export * from './data';

const enhancedRecalcDataApi = recalcOpenApi.enhanceEndpoints({
  endpoints: {
    dataGetCollectionAsyncByqueryOptions: {
      query: (queryArg) => {
        const params = new URLSearchParams();
        if (queryArg.orderby) params.append('orderby', queryArg.orderby);
        if (queryArg.orderbydesc)
          params.append('orderbydesc', queryArg.orderbydesc);
        for (const timestamp of queryArg.timestamp) {
          params.append('Timestamp', timestamp);
        }
        params.append('UnitId', queryArg.unitId);
        params.append('AggregateType', queryArg.aggregateType);
        params.append('DataType', queryArg.dataType);
        params.append('UnitTypeInputId', queryArg.unitTypeInputId);
        if (queryArg.top !== undefined)
          params.append('top', String(queryArg.top));
        if (queryArg.skip !== undefined)
          params.append('skip', String(queryArg.skip));
        return { url: `/Data?${params.toString()}` };
      },
    },
  },
});

export const {
  useDataGetCollectionAsyncByqueryOptionsQuery,
  useLazyDataGetCollectionAsyncByqueryOptionsQuery,
} = enhancedRecalcDataApi;
